(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_showcase-announcements"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kaizen-marquee')) {
    customElements.define(
      'kaizen-marquee',
      class extends HTMLElement {
        connectedCallback() {
          const button = this.querySelector('[data-marquee-toggle]');

          if (!button || button.dataset.marqueeBound === 'true') return;

          button.dataset.marqueeBound = 'true';
          button.addEventListener('click', () => {
            const isPaused = this.dataset.paused !== 'true';

            this.dataset.paused = String(isPaused);
            button.setAttribute('aria-pressed', String(isPaused));
            button.setAttribute('aria-label', isPaused ? button.dataset.resumeLabel : button.dataset.pauseLabel);
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["footer-localization"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
   document.querySelectorAll('.footer-language-selector details[open]').forEach((details) => { if (!details.contains(event.target)) details.open = false; });
 });
 document.addEventListener('keydown', (event) => {
   const details = event.target.closest('.footer-language-selector details[open]');
   if (details && event.key === 'Escape') { event.preventDefault(); details.open = false; details.querySelector('summary').focus(); }
 });
 document.addEventListener('focusin', (event) => {
   document.querySelectorAll('.footer-language-selector details[open]').forEach((details) => { if (!details.contains(event.target)) details.open = false; });
 });
  } catch(e) { console.error(e); }
})();

})();
